import { useTheme } from "@emotion/react";
import { Box, Paper, Typography } from "@mui/material";
import useStyles from "./styles";

// Bloco de seção do painel de atendimento: cabeçalho com ícone e título, ação
// opcional à direita e o conteúdo num cartão.
//
// Antes cada seção repetia a dupla "Box com título" + "Box com margem fixa de
// 40px" + "Paper". Além de repetitivo, o gutter fixo era o que quebrava a tela
// no celular. Aqui o espaçamento vem dos tokens e acompanha a largura.
//
// `action` recebe o que for para a direita do título — um botão de copiar, um
// "Abrir OS".
export default function SectionCard({
  icon,
  title,
  action,
  children,
  disablePadding = false,
  contentSx = {},
  sx = {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={{ ...styles.container, ...sx }}>
      <Box sx={styles.header}>
        <Box sx={styles.titulo}>
          {icon}
          <Typography component="h3" sx={styles.tituloTexto}>
            {title}
          </Typography>
        </Box>

        {action && <Box sx={styles.acao}>{action}</Box>}
      </Box>

      <Paper
        variant="outlined"
        elevation={0}
        sx={{
          ...styles.cartao,
          ...(disablePadding ? {} : styles.cartaoPadding),
          ...contentSx,
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}
